/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class CacheAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public clearAllCaches(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/4Ey7HdKLhNlrCU0An5Qioql8IcLLcue9/cache",
    });
  }
}
